module.exports = __webpack_public_path__ + "static/media/strategicMobile.737788ff.png";